import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Youtube, Mail, Phone, MapPin } from 'lucide-react';
import { FOOTER_LINKS } from '../mock/mockData';
import logo from '../assets/logo.png';

const LOGO_URL = logo;

const Footer = () => {
  return (
    <footer className="bg-[#1F2A44] text-[#FAF7F2] mt-20">
      <div className="max-w-7xl mx-auto px-4 py-14 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2">
<Link to="/" className="inline-block mb-4">
<div className="bg-[#FAF7F2] px-5 py-3 rounded-md flex flex-col items-center">
  <img
    src={LOGO_URL}
    alt="FOSEN"
    className="h-18 md:h-20 w-auto object-contain"
  />
</div>
</Link>
          <p className="text-sm text-[#FAF7F2]/70 leading-relaxed max-w-md">
            FOSEN — Making Homes Beautiful. Premium furniture crafted in India, delivered to your door. Sofas, beds, dining, recliners and more.
          </p>
          <div className="flex gap-3 mt-5">
            {[Instagram, Facebook, Youtube].map((Icon, i) => (
              <a key={i} href="#" className="w-9 h-9 rounded-full border border-[#FAF7F2]/30 flex items-center justify-center hover:bg-[#E8B530] hover:border-[#E8B530] hover:text-[#1F2A44] transition-all">
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-[#E8B530] font-semibold mb-4 text-sm uppercase tracking-wider">Shop</h4>
          <ul className="space-y-2 text-sm text-[#FAF7F2]/80">
            {FOOTER_LINKS.shop.map((s) => (
              <li key={s}><Link to="/shop" className="hover:text-[#E8B530] transition-colors">{s}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-[#E8B530] font-semibold mb-4 text-sm uppercase tracking-wider">Company</h4>
          <ul className="space-y-2 text-sm text-[#FAF7F2]/80">
            {FOOTER_LINKS.company.map((s) => (
              <li key={s}><Link to="/about" className="hover:text-[#E8B530] transition-colors">{s}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-[#E8B530] font-semibold mb-4 text-sm uppercase tracking-wider">Get in touch</h4>
          <ul className="space-y-3 text-sm text-[#FAF7F2]/80">
            <li className="flex items-start gap-2"><Phone size={14} className="mt-0.5 text-[#E8B530]" /> +91 88618 41594</li>
            <li className="flex items-start gap-2"><Mail size={14} className="mt-0.5 text-[#E8B530]" /> hello@fosen.com</li>
            <li className="flex items-start gap-2"><MapPin size={14} className="mt-0.5 text-[#E8B530]" /> Showrooms across Bengaluru</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#FAF7F2]/15">
        <div className="max-w-7xl mx-auto px-4 py-5 flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-[#FAF7F2]/60">
          <p>© {new Date().getFullYear()} FOSEN. All rights reserved. Making Homes Beautiful.</p>
          <div className="flex gap-4">
            <Link to="/about" className="hover:text-[#E8B530]">Privacy Policy</Link>
            <Link to="/about" className="hover:text-[#E8B530]">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
